/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { AppServiceSyncMachineConfig } from "../../../state-machine";
import {
  triggerTotalSales,
  triggerProvisionalPoliciesCount,
  triggerActualPoliciesCount,
  triggerSalesValue,
  triggerRegionStats,
  triggerRegionStatsPeriodicity,
  triggerTotalGrantSum,
  triggerConsumedGrantSum,
  triggerConsumedPoliciesCount
} from "./states";
import uuid from "react-uuid";

export const ANALYTICS_RESULT_FORMATTER_CONFIG: AppServiceSyncMachineConfig = {
  init: "START",
  transitions: [
    {
      name: "triggerTotalSales",
      from: "START",
      to: "TOTAL_SALES",
    },
    {
      name: "triggerProvisionalPoliciesCount",
      from: "TOTAL_SALES",
      to: "PROVISIONAL_POLICIES_COUNT",
    },
    {
      name: "triggerActualPoliciesCount",
      from: "PROVISIONAL_POLICIES_COUNT",
      to: "TOTAL_GRANT_SUM",
    },
    {
      name: "triggerTotalGrantSum",
      from: "TOTAL_GRANT_SUM",
      to: "CONSUMED_GRANT_SUM",
    },
    {
      name: "triggerConsumedGrantSum",
      from: "CONSUMED_GRANT_SUM",
      to: "CONSUMED_GRANT_POLICIES",
    },
    {
      name: "triggerConsumedPoliciesCount",
      from: "CONSUMED_GRANT_POLICIES",
      to: "ACTUAL_POLICIES_COUNT",
    },
    {
      name: "triggerSalesValue",
      from: "ACTUAL_POLICIES_COUNT",
      to: "SALES_VALUE",
    },
    {
      name: "triggerRegionStats",
      from: "SALES_VALUE",
      to: "REGION_STATS",
    },
    {
      name: "triggerRegionStatsPeriodicity",
      from: "REGION_STATS",
      to: "REGION_STATS_PERIODICITY",
    },
    {
      name: "triggerEnd",
      from: "REGION_STATS_PERIODICITY",
      to: "END",
    },
  ],
  methods: {
    onTriggerTotalSales: triggerTotalSales,
    onTriggerProvisionalPoliciesCount: triggerProvisionalPoliciesCount,
    onTriggerActualPoliciesCount: triggerActualPoliciesCount,
    onTriggerTotalGrantSum:triggerTotalGrantSum,
    onTriggerConsumedGrantSum:triggerConsumedGrantSum,
    onTriggerConsumedPoliciesCount:triggerConsumedPoliciesCount,
    onTriggerSalesValue: triggerSalesValue,
    onTriggerRegionStats: triggerRegionStats,
    onTriggerRegionStatsPeriodicity: triggerRegionStatsPeriodicity,
  },
};
